import { render } from "./zhenggaohuli-news.vue?vue&type=template&id=117f22d3&scoped=true"
import script from "./zhenggaohuli-news.vue?vue&type=script&lang=js"
export * from "./zhenggaohuli-news.vue?vue&type=script&lang=js"

import "./zhenggaohuli-news.vue?vue&type=style&index=0&id=117f22d3&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\shview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-117f22d3"]])

export default __exports__